var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgSend = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.625 9.7814C18.5 9.56265 18.3125 9.4064 18.0937 9.2814L3.68747 1.2189C3.43747 1.0939 3.15622 1.0314 2.87497 1.06265C2.59372 1.0939 2.34372 1.18765 2.12497 1.37515C1.90622 1.56265 1.74997 1.81265 1.68747 2.06265C1.59372 2.3439 1.62497 2.62515 1.71872 2.9064L4.40622 10.5001L1.71872 18.0939C1.62497 18.3751 1.62497 18.6564 1.68747 18.9064C1.74997 19.1876 1.90622 19.4064 2.12497 19.5939C2.34372 19.7814 2.59372 19.8751 2.87497 19.9064C2.90622 19.9064 2.96872 19.9064 2.99997 19.9064C3.21872 19.9064 3.46872 19.8439 3.68747 19.7189L18.0937 11.6564C18.3125 11.5314 18.5 11.3751 18.625 11.1564C18.75 10.9376 18.8125 10.6876 18.8125 10.4689C18.8125 10.2501 18.75 10.0002 18.625 9.7814ZM3.06247 2.4689L16.125 9.7814H5.65622L3.06247 2.4689ZM3.06247 18.5314L5.68747 11.2189H16.1562L3.06247 18.5314Z",
    fill: "#6B7280"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgSend);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/send.901ff5cb057a1139908289f358b30a9f.svg";